function createUtm(query) {
    if (query.utm_source || query.utm_medium || query.utm_campaign || query.utm_term || query.utm_content) {
        const utm = {
            utmSource: query.utm_source,
            utmMedium: query.utm_medium,
            utmCampaign: query.utm_campaign,
            utmTerm: query.utm_term,
            utmContent: query.utm_content
        }
        return utm;
    }else {
        return null;
    }

}

export {
    createUtm
}